import { GetRequest, PostRequest } from "../../../plugins/https";
import { getPopUp, setPopUp } from "./action";
import { ADD_POPUP, GET_POPUP } from "./actionType";

export const addPopUp = (id) => async (dispatch) => {
  try {
    const res = await PostRequest("/popup", { id });
    dispatch(setPopUp(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const getAllPopUp = async (dispatch) => {
  try {
    const res = await GetRequest("/popup");
    dispatch(getPopUp(res.data));
  } catch (error) {
    console.error("Error getting PopUp: ", error);
  }
};

const initialState = {
  currentPopUp: null, // Store the most recently added popup
  allPopUps: [], // Store all popup data
};

export const popUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_POPUP:
      return {
        ...state,
        currentPopUp: action.payload, // Store the newly added popup
      };
    case GET_POPUP:
      return {
        ...state,
        allPopUps: action.payload, // Replace with all popups fetched from the API
      };
    default:
      return state;
  }
};
